// @vendors
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// @helpers
import { recordLinkV2 } from 'utilities/tagging';
import { getFlowStep, isFlowMigrationAllowed } from '../utilities/migration.utils';

// @constants
import { MIGRATION_STATE, MODAL_TYPE } from '../migrationUsersBranchView.constants';

// @ actions
const { hideAppHeader, showAppHeader } = require('actions/screen');

export const useMigration = () => {
  const immMigration = useSelector(state => state.migration);
  const [migrationState, setMigrationState] = useState(getFlowStep(immMigration.getIn(['status'])));
  const [isFetching, setIsFetching] = useState(true);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [modalType, setModalType] = useState(MODAL_TYPE.DEFAULT);
  const immProfile = useSelector(state => state.profile);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(hideAppHeader());
    return () => {
      dispatch(showAppHeader());
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [migrationState]);

  useEffect(() => {
    if (!immMigration.getIn(['fetching']) && immMigration.getIn(['status'])) {
      setMigrationState(getFlowStep(immMigration.getIn(['status'])));
      setIsFetching(false);
    }
  }, [immMigration.getIn(['fetching'])]);

  const handleContinue = () => {
    setShowLeaveModal(false);
    setMigrationState(MIGRATION_STATE.TERMS_AND_CONDITIONS);
  };
  const handleCancel = () => {
    setShowLeaveModal(false);
    setMigrationState(MIGRATION_STATE.REJECTED);
  };

  const handleChangeMigrationState = (state, url = undefined) => {
    setMigrationState(state);
  };

  const handleExitHeader = (modalType = DEFAULT) => {
    setModalType(modalType);
    setShowLeaveModal(true);
    const option = {
      [MIGRATION_STATE.INITIAL]: 'paso_0',
      [MIGRATION_STATE.TERMS_AND_CONDITIONS]: 'paso_1',
      [MIGRATION_STATE.VIDEOCALL_INFO]: 'paso_2',
    };
    recordLinkV2({
      categoriaEvento: 'interaccion en migracion',
      accionEvento: option[migrationState] || option[MIGRATION_STATE.INITIAL],
      etiquetaEvento: 'salir',
      action: 'exit',
      format: 'button',
      component: 'header',
      element: 'exit',
    });
  };

  const handleCloseModal = () => {
    setShowLeaveModal(false);
  };

  const getIsMigrationRouteAllowed = () =>
    immProfile.get('originCountry') &&
    immProfile.get('originCountry') == 'DE' &&
    immMigration.getIn(['fetched']) &&
    isFlowMigrationAllowed(immMigration.getIn(['status']));

  return {
    states: {
      isFetching,
      migrationState,
      modalType,
      showLeaveModal,
    },
    actions: {
      getIsMigrationRouteAllowed,
      handleCancel,
      handleChangeMigrationState,
      handleCloseModal,
      handleContinue,
      handleExitHeader,
    },
  };
};
